<div class="gameHeader">
  <!-- 'leftbtn' or 'rightbtn', which will come it depends on condition -->
  <button class="back leftbtn">
    <a (click)="loadBack()">
      <svg class="svgicon">
        <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
      </svg>
    </a>
  </button>
  <div class="pageIndicator">
    <div class="title"><span class="gamename">{{'dge.drawId' | translate}}:#{{drawNumber}}</span><span
        class="ticketNum">{{'dge.DateandTime' | translate}} {{drawDateTime | date: 'MMM dd - HH:mm'  }} </span></div>
  </div>
</div>
<div class="drawMachinePageWrap">
  <div class="drawMachineOuterWrap">
    <div class="sectionWrapper">
      <div class="drawMachineWrap">
        <iframe width="560" height="315" #drawmachine id="drawmachine" [src]="iframe_src" frameborder="0"
          allow="accelerometer; encrypted-media; gyroscope;"></iframe>
      </div>
    </div>
  </div>
  <div class="drawMachineTktWrap">
    <div class="sectionWrapper" *ngIf="showTickets">
      <div class="tkt-section" *ngFor="let item of myTickets;let ticketIndex = index;">
        <div class="section">
          <div class="tkt-betPlayedWrap">
            <div class="title">
              <div class="lt tktNum"><span class="label">{{'dge.ticket_number' | translate}}</span><span
                  class="num">{{ item.ticketNumber }}</span></div>
              <div class="rt betVal"><span class="label">{{'dge.bet' | translate}}</span>
                <!-- <div class="amountWrap" innerHTML="{{item.ticketDetails.saleAmount | custCurrency}}"></div> -->
                <div class="amountWrap" *ngIf="clientCode !='guinee'" innerHTML="{{item.ticketDetails.saleAmount | custCurrency}}"></div>
                <div class="amountWrap" *ngIf="clientCode =='guinee'" innerHTML="{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(item.ticketDetails.saleAmount)}}"></div>
              </div>
            </div>


            <div class="playedBingoCardsWrap" *ngIf="gameCode == 'BingoSeventyFive3'">
              <div class="gameBingo">
                <div class="cardWrapper {{cardClass}}">
                  <div class="cardGroup" *ngFor="let panel of item?.ticketData?.drawWinList[0]?.panelWinList;let pIndex = index;">
                    <div class="cardWrap">
                      <span class="bingoIconWrap" [ngClass]="{'show': false}">
                        <img src="assets/images/bingo.svg">
                      </span>
                      <div class="bingoWinPriceWrap"
                        *ngIf="panel?.winningAmt != 0 && item?.drawStatusForticket == 'CLAIM_ALLOW'">
                        <!-- <div class="bingoWinPrice" innerHTML="{{panel?.winningAmt | custCurrency}}"></div> -->
                        <div class="bingoWinPrice" *ngIf="clientCode !='guinee'" innerHTML="{{panel?.winningAmt | custCurrency}}"></div>
                        <div class="bingoWinPrice" *ngIf="clientCode =='guinee'" innerHTML="{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(panel?.winningAmt)}}"></div>
                      </div>
                      <div class="card">
                        <div class="cardTitle">
                          <span>B</span>
                          <span>I</span>
                          <span>N</span>
                          <span>G</span>
                          <span>0</span>
                        </div>
                        <div class="cardNumWrap">
                          <ul>
                            <ng-container *ngFor="let first of panel?.pickedData; let j = index">
                              <li class="num" *ngFor="let second of first; let k = index" [ngClass]="{
                                  'Free': second == 'X',
                                  'empty': second == '_',
                                  'winOut': false,
                                  'highlight': item?.winResult?.includes(second),
                                  'win': ticketMatchData[0]?.data[drawIndex][pIndex]?.includes(second)
                                }">
                                <span *ngIf="second == 'X'">
                                  <svg class="svgicon starIcon">
                                    <use xlink:href="assets/images/sprite-sheet.svg#icon-star">
                                    </use>
                                  </svg>
                                </span>
                                <span *ngIf="second != 'X'">{{(second !=  '_' ? second : '')}}</span>
                              </li>
                            </ng-container>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="title" *ngIf="gameCode == 'LuckySix' && checkDrawAddons()">
              <div class="lt d-flex">{{'dge.draw_result' | translate}} <div
                  class="iconSymbol flag flag--{{clientCode}}"></div>
              </div>
              <div class="rt">
                <span class="label text-capitalize">{{'dge.win' | translate}}:</span>
                <span class="value">{{item?.ticketData?.drawWinList[0]?.winningMultiplierInfo?.value}}x</span>
              </div>
            </div>
            <ng-container *ngIf="gameCode !='BingoSeventyFive3'">
            <ng-container *ngFor="let draws of item.ticketData?.drawWinList; let drawIndex = index;">
              <div class="playedRowWrap">
                <div class="item-row" *ngFor="let panel of draws?.panelWinList;let pIndex = index;">
                  <div class="col1" *ngIf="panelType == 1">
                    <ng-container *ngIf="gameCode != 'powerball' || gameCode != 'BingoSeventyFive3'">
                      <div class="selection"
                        *ngIf="panel.pickType != 'Banker' && panel.pickType != 'Banker1AgainstAll' && betData[panel.playType]?.winMode == 'MAIN'">
                        <div class="ballBox">
                          <div
                            class="ballWrap wAni ball-{{numberArray[pickedNo]?.color == '' ? 'orange' : numberArray[pickedNo]?.color}} {{checkAcHOMain(pickedNo)}}"
                            *ngFor="let pickedNo of panel.pickedData; let k = index;"
                            [ngClass]="{'cloverBg': gameCode == 'LuckySix' && checkClover(pickedNo)}">
                            {{pickedNo}}
                          </div>
                        </div>
                      </div>
                      <div class="selection"
                        *ngIf="panel.pickType == 'Banker' || panel.pickType == 'Banker1AgainstAll'">
                        <div class="txt">UL-</div>
                        <div class="ballBox">
                          <div class="ballWrap ball-{{numberArray[pickedNo]?.color}} {{checkAcHOMain(pickedNo)}}"
                            *ngFor="let pickedNo of panel.pickedData[0]; let k = index;">
                            {{pickedNo}}
                          </div>
                        </div>
                      </div>
                      <div class="selection"
                        *ngIf="panel.pickType == 'Banker' || panel.pickType == 'Banker1AgainstAll'">
                        <div class="txt">LL-</div>
                        <div class="ballBox">
                          <div class="ballWrap ball-{{numberArray[pickedNo]?.color}} {{checkAcHOMain(pickedNo)}}"
                            *ngFor="let pickedNo of panel.pickedData[1]; let k = index;">
                            {{pickedNo}}
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="gameCode == 'powerball'">
                      <div class="selection selwrap-6by42" *ngIf="betData[panel.playType]?.winMode == 'MAIN'">
                        <div class="ballBox">
                          <div
                            class="ballWrap wAni ball-{{numberArray[pickedNo]?.color == '' ? 'orange' : numberArray[pickedNo]?.color}} {{checkAcHOPowerball(pickedNo, 0)}}"
                            *ngFor="let pickedNo of panel.pickedData[0]; let k = index;">
                            {{pickedNo}}
                          </div>
                        </div>
                        <span class="plusSign">+</span>
                        <div class="ballBox">
                          <div
                            class="ballWrap wAni ball-{{numberArray2[pickedNo]?.color == '' ? 'orange' : numberArray2[pickedNo]?.color}} {{checkAcHOPowerball(pickedNo, 1)}}"
                            *ngFor="let pickedNo of panel.pickedData[1]; let k = index;">
                            {{pickedNo}}
                          </div>
                        </div>
                      </div>
                      <div class="selection"
                        *ngIf="panel.pickType == 'Banker' || panel.pickType == 'Banker1AgainstAll'">
                        <div class="txt">UL-</div>
                        <div class="ballBox">
                          <div class="ballWrap ball-{{numberArray[pickedNo]?.color}} {{checkAcHOMain(pickedNo)}}"
                            *ngFor="let pickedNo of panel.pickedData[0]; let k = index;">
                            {{pickedNo}}
                          </div>
                        </div>
                      </div>
                      <div class="selection"
                        *ngIf="panel.pickType == 'Banker' || panel.pickType == 'Banker1AgainstAll'">
                        <div class="txt">LL-</div>
                        <div class="ballBox">
                          <div class="ballWrap ball-{{numberArray[pickedNo]?.color}} {{checkAcHOMain(pickedNo)}}"
                            *ngFor="let pickedNo of panel.pickedData[1]; let k = index;">
                            {{pickedNo}}
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <div class="selection" *ngIf="betData[panel.playType]?.winMode != 'MAIN'">
                      <div class="valuebox {{checkAcHOSide(panel.playType, panel.pickType)}}"
                        *ngIf="betData[panel.playType]?.winMode == 'COLOR'">
                        <div
                          class="colorDot ball-{{betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1] | lowercase}}">
                        </div>
                        {{'dge.'+getSideBetPickName(betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1]) | translate}}
                      </div>
                      <div class="valuebox {{checkAcHOSide(panel.playType, panel.pickType)}}"
                        *ngIf="betData[panel.playType]?.winMode == 'SUM'">
                        {{betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[0] == 0 ? '&lt; ' + betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[2] : '&gt;
                          ' + betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[0]  | titlecase}}
                      </div>
                      <div class="valuebox {{checkAcHOSide(panel.playType, panel.pickType)}}"
                        *ngIf="betData[panel.playType]?.winMode == 'ODD_EVEN'">
                        {{'dge.'+getSideBetPickName(betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue.split('<')[1]) | translate}}
                      </div>
                      <div class="valuebox {{checkAcHOSide(panel.playType, panel.pickType)}}"
                        *ngIf="betData[panel.playType]?.winMode == 'PATTERN'">
                        {{'dge.'+getSideBetPickName(betData[panel.playType]?.pickTypeData.pickType[panel.pickType].range[0].pickValue) | translate}}
                      </div>
                    </div>
                    <div class="detail small" *ngIf="gameCode != 'powerball'">
                      <span>
                        {{(betData[panel.playType]?.winMode == 'MAIN' ? 'dge.mainbet' : 'dge.sidebet') | translate}}
                      </span>
                      <span class="separator">|</span>
                      <span>
                        {{'dge.'+betData[panel.playType]?.betDispName | translate}}
                      </span>
                      <span class="separator" *ngIf="betData[panel.playType]?.winMode == 'MAIN'">|</span>
                      <span *ngIf="betData[panel.playType]?.winMode == 'MAIN'">
                        {{'dge.'+getPickName(betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.code, betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.name, panel?.quickPickType) | translate}}
                      </span>
                      <ng-container *ngIf="betData[panel.playType]?.winMode == 'MAIN'">
                        <span class="separator">-</span>
                        <span>
                          {{numberOfLines(ticketIndex, drawIndex, pIndex, gameCode)}}
                          {{(numberOfLines(ticketIndex, drawIndex, pIndex, gameCode) > 1 ? 'dge.lines' : 'dge.line') | translate}}
                        </span>
                      </ng-container>
                    </div>
                    <div class="detail small" *ngIf="gameCode == 'powerball'">
                      <span>
                        {{'dge.'+betData[panel.playType]?.betDispName | translate}}
                      </span>
                      <span class="separator">|</span>
                      <span>
                        {{'dge.'+getPickName(betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.code, betData[panel.playType]?.pickTypeData?.pickType[panel.pickType]?.name, panel?.quickPickType) | translate}}
                      </span>
                    </div>
                  </div>
                  <div class="col1" *ngIf="panelType == 3">
                    <div class="selection">
                      <div class="itemSymWrap wAni {{checkAcHOMain(pickedNo)}}"
                        *ngFor="let pickedNo of panel.pickedData; let k = index;">
                        <div class="itemSym icon-{{iconMapping[pickedNo]}}">
                          <svg class="svgicon">
                            <use [attr.xlink:href]="'assets/images/fortune-sprite.svg#icon-'+iconMapping[pickedNo]">
                            </use>
                          </svg>
                        </div>
                        <div class="label">{{'dge.'+iconMapping[pickedNo] | translate}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col1" *ngIf="panelType == 2">
                    <div class="selection wAni"  *ngIf="gameCode != 'BichoRapido' && gameCode != 'BingoSeventyFive3'">
                      <div class="valuebox {{checkAcHOMainThai(panel)}}">
                        {{panel?.pickedData?.join('')}}
                      </div>
                    </div>
                    <div class="detail small"  *ngIf="gameCode != 'BichoRapido' && gameCode != 'BingoSeventyFive3'">
                      <span>
                        {{((betData[panel?.playType]?.betGroup == "3Digit") ? 'dge.3_digit' : ((betData[panel?.playType]?.betGroup == "2Digit") ? 'dge.2_digit' : ((betData[panel?.playType]?.betGroup == "1Digit") ? 'dge.1_digit' : ''))) | translate}}
                      </span>
                      <span class="separator">:</span>
                      <span
                        innerHTML="{{'dge.GD-'+getBetName(betData[panel?.playType]?.betDispName)+'-'+betData[panel?.playType]?.pickTypeData?.pickType[panel?.pickType]?.name | translate}}"></span>
                    </div>
                    <div class="selection"  *ngIf="gameCode == 'BichoRapido'">
                      <div class="valuebox" *ngIf="panel?.playType == 'Centena1to5' || panel?.playType == 'Centena'">x{{panel?.pickedData?.join('')}}</div>
                      <div class="valuebox" *ngIf="panel?.playType != 'Centena1to5' && panel?.playType != 'Centena' && panel?.playType != 'TurnoDeGroupo' && panel?.playType != 'Groupo'">{{panel?.pickedData?.join('')}}</div>
                      <div class="animalSelectBox" *ngIf="panel?.playType == 'TurnoDeGroupo' || panel?.playType == 'Groupo'">
                        <ng-container *ngFor="let item of panel?.pickedData">
                          <div class="title">
                              <div class="num">{{item}}</div>
                              <div class="name">{{getAnimalDetails(item).name}}</div>
                          </div>
                          <div class="img-num-wrap">
                              <div class="img">
                                  <img src="./assets/images/animals/{{item}}{{getAnimalDetails(item).name}}.jpg" alt="{{getAnimalDetails(item).name}}">
                              </div>
                              <div class="core-nums">
                                  <div class="num">{{getAnimalDetails(item).numArray[0]}}</div>
                                  <div class="num">{{getAnimalDetails(item).numArray[1]}}</div>
                                  <div class="num">{{getAnimalDetails(item).numArray[2]}}</div>
                                  <div class="num">{{getAnimalDetails(item).numArray[3]}}</div>
                              </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div class="detail small"  *ngIf="gameCode == 'BichoRapido'">{{'dge.'+ betData[panel?.playType]?.betDispName | translate}}</div>
                  </div>
                  <div class="col2">
                    <!-- <div class="amountWrap" *ngIf="gameCode != 'BingoSeventyFive3'" innerHTML="{{panel?.lineAmountTicketCurr | custCurrency}}"></div> -->
                    <div class="amountWrap" *ngIf="clientCode !='guinee' && gameCode != 'BingoSeventyFive3'" innerHTML="{{panel?.lineAmountTicketCurr | custCurrency}}"></div>
                    <div class="amountWrap" *ngIf="clientCode =='guinee' && gameCode != 'BingoSeventyFive3'"><span class="no-wrap">{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(panel?.lineAmountTicketCurr)}}</span></div>
                  </div>
                  <div class="col4" *ngIf="panel?.winningAmt != 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW' && showResult">
                    <div class="amountWrap winning">
                      <span class="small">{{'dge.won' | translate}}</span>
                      <!-- <div class="currencywrap" innerHTML="{{panel?.winningAmt | custCurrency}}"></div> -->
                      <div class="currencywrap" *ngIf="clientCode !='guinee'" innerHTML="{{panel?.winningAmt | custCurrency}}"></div>
                      <div class="currencywrap" *ngIf="clientCode =='guinee'"><span class="no-wrap">{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(panel?.winningAmt)}}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="showResult && draws?.winResult != 'RESULT AWAITED' && draws.winningAmt > 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW' && draws?.panelWinList[0]?.status != 'CANCELLED'"
                class="resultMsgWrap win">
                <p>
                  {{'dge.you_have_won' | translate}}
                  <!-- <span class="amountWrap" innerHTML="{{draws?.winningAmt | custCurrency}}"></span> -->
                  <span class="amountWrap" *ngIf="clientCode !='guinee'" innerHTML="{{draws?.winningAmt | custCurrency}}"></span>
                  <span class="amountWrap" *ngIf="clientCode =='guinee'" innerHTML="{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(draws?.winningAmt)}}"></span>
                </p>
              </div>
              <div
                *ngIf="showResult && draws?.winResult != 'RESULT AWAITED' && draws.winningAmt <= 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW' && draws?.panelWinList[0]?.status != 'CANCELLED' "
                class="resultMsgWrap lose">
                <p>{{'dge.better_luck_next_time' | translate}}</p>
              </div>
              <div *ngIf="showResult && draws?.panelWinList[0]?.status == 'CANCELLED'" class="resultMsgWrap cancel">
                <p>{{'sle.ticket_cancelled' | translate}}</p>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="gameCode =='BingoSeventyFive3'">
            <ng-container *ngFor="let draws of item.ticketData?.drawWinList; let drawIndex = index;">
            <div
            *ngIf="draws?.winResult != 'RESULT AWAITED' && draws.winningAmt > 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW' && draws?.panelWinList[0]?.status != 'CANCELLED'"
            class="resultMsgWrap win">
            <p>
              {{'sle.you_have_won' | translate}}
              <!-- <span class="amountWrap" innerHTML="{{draws?.winningAmt | custCurrency}}"></span> -->
              <span class="amountWrap" *ngIf="clientCode !='guinee'" innerHTML="{{draws?.winningAmt | custCurrency}}"></span>
              <span class="amountWrap" *ngIf="clientCode =='guinee'" innerHTML="{{userInfo?.currDisplay | currencySymbol}} {{numberWithSpaces(draws?.winningAmt)}}"></span>
            </p>
          </div>
          <div
            *ngIf="draws?.winResult != 'RESULT AWAITED' && draws.winningAmt <= 0 && draws?.drawStatusForticket == 'CLAIM_ALLOW' && draws?.panelWinList[0]?.status != 'CANCELLED'"
            class="resultMsgWrap lose">
            <p>{{'sle.better_luck_next_time' | translate}}</p>
          </div>
          <div *ngIf="draws?.panelWinList[0]?.status == 'CANCELLED'" class="resultMsgWrap cancel">
            <p>{{'sle.ticket_cancelled' | translate}}</p>
          </div>
          </ng-container>
        </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="msg-section" *ngIf="playerLogin && showTickets == false">
      <h2>{{'dge.no_ticket_purchase' | translate}}</h2>
      <div class="buttonWrap">
        <button routerLink="{{gameLink}}">{{'dge.buy_tickets' | translate}}</button></div>
    </div>
    <div class="msg-section" *ngIf="playerLogin == false">
      <div class="buttonWrap">
        <button (click)="openLoginPopup()">{{'dge.login' | translate}}</button>
      </div>
    </div>
  </div>
</div>
